// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsContainer_container__jg5sZ"};